// The one toolbar item that gives up space, so its buttons overflow it
.shrinkable {
  display: flex;
  align-items: center;
  gap: var(--dixa-size-spacer-100);
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
}

.tooltipName {
  font-weight: var(--dixa-typography-weight-semibold);
}

.pinnedDivider {
  align-self: stretch;
}

.undoDivider {
  align-self: stretch;
  margin-right: 0;
}
